import reactComponentLoader from 'scripts/react-component-loader'

import Cart from './index'
import CartButton from './components/CartButton'

reactComponentLoader(Cart, '[data-cart]')
reactComponentLoader(CartButton, '[data-cart-button]')
